import {
  Col,
  Container,
  TypographyElement,
  MediaQuery
} from 'UI'
import { createUseStyles, useTheme } from 'react-jss'
import Funding from './Funding'
import style from './style'

const useStyles = createUseStyles(style)

export default ({
  Title,
  Subtitle,
  PresentationVideoThumbnail,
  loading,
  IsNew
}) => {
  const theme = useTheme()
  const { container, funding, newBadge } = useStyles({ loading, PresentationVideoThumbnail })
  return (
    <Container className={container}>
      <Col grid={12} mgrid={12} sgrid={12} direction='column' gap={16} tabletGap={16} mobileGap={16}>
        {
          IsNew
            ? <div className={newBadge}><TypographyElement variant='caption' color={theme.error[0]} spacing='3px 8px'>NOUVEAU</TypographyElement></div>
            : null
         }

        <TypographyElement
          variant='heading1'
          Component='h1'
        >
          {Title}
        </TypographyElement>
        <TypographyElement
          variant='body1'
        >
          {Subtitle}
        </TypographyElement>
        <MediaQuery ShowOnDesktop>
          <Funding className={funding} />
        </MediaQuery>
      </Col>
    </Container>
  )
}
